import { connect } from 'react-redux';
import { MainWrapperComponent } from './MainWrapperComponent'

const mapStateToProps = (state: any): any => {
	return {
	}
}

const mapDispatchToProps: any = {
}

export const MainWrapperContainer = connect(mapStateToProps, mapDispatchToProps)(MainWrapperComponent)
